import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "手続きページのタイトルをカスタムできます。設定しない場合、名称がそのまま使われます。",
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureTitleInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="ページタイトル" />
      <InputNoticeList notices={notices} />
      <SimpleTextInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("procTitle")}
      />
    </div>
  );
};
